module.exports = __webpack_public_path__ + "img/mir.93c42af0.svg";